import { render } from "./KpiGlobalPerformancePanel.vue?vue&type=template&id=c030a0fa&scoped=true&ts=true"
import script from "./KpiGlobalPerformancePanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./KpiGlobalPerformancePanel.vue?vue&type=script&setup=true&lang=ts"

import "./KpiGlobalPerformancePanel.vue?vue&type=style&index=0&id=c030a0fa&scoped=true&lang=css"

import exportComponent from "/var/www/redontrack/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c030a0fa"],['__file',"resources/js/views/home/components/kpi-global-performance/KpiGlobalPerformancePanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c030a0fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c030a0fa', __exports__)) {
    console.log('reload')
    api.reload('c030a0fa', __exports__)
  }
  
  module.hot.accept("./KpiGlobalPerformancePanel.vue?vue&type=template&id=c030a0fa&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('c030a0fa', render)
  })

}


export default __exports__